<template>
  <v-card :color="'rgb(250, 250, 250)'" class="elevation-0">
    <v-toolbar dense :color="colorBarraFormulario" dark flat>
      <v-toolbar-title v-bind:style="{ color: colorFondo300 }">
        <h5 v-bind:style="{ color: 'white' }">FICHA DE LA REPARACIÓN</h5>
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-icon size="30" :color="'white'" @click="_cerrarVentana"
        >mdi-close-circle</v-icon
      >
    </v-toolbar>
    <v-card-text>
      <v-row class="mt-8" dense>
        <v-col class="ml-0">
          <v-row dense class="mx-4 mb-4">
            <v-col>
              <v-menu
                :dark="dark"
                v-model="date1"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :dark="dark"
                    clearable
                    dense
                    outlined
                    v-model="modelReparacion.fecha_inicial"
                    label="Fecha de inicio"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-on="on"
                    hide-details
                  ></v-text-field>
                </template>
                <v-date-picker
                  :dark="dark"
                  color="success"
                  locale="es"
                  v-model="modelReparacion.fecha_inicial"
                  @input="date1 = false"
                  first-day-of-week="1"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <v-col>
              <v-menu
                :dark="dark"
                v-model="date2"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :dark="dark"
                    clearable
                    dense
                    outlined
                    v-model="modelReparacion.fecha_final"
                    label="Fecha final"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-on="on"
                    hide-details
                  ></v-text-field>
                </template>
                <v-date-picker
                  :dark="dark"
                  color="success"
                  locale="es"
                  :min="modelReparacion.fecha_inicial"
                  v-model="modelReparacion.fecha_final"
                  @input="date2 = false"
                  first-day-of-week="1"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>

          <v-row dense class="mx-4 mb-6">
            <v-col cols="6">
              <v-select
                :items="bicis"
                label="Seleccione la bici"
                dense
                :dark="dark"
                outlined
                v-model="modelReparacion.bici"
                item-text="numero"
                return-object
                hide-details
              >
                <template slot="selection" slot-scope="data">
                  {{ data.item.talla + data.item.numero }}
                </template>

                <template slot="item" slot-scope="data">
                  {{ data.item.talla + data.item.numero }}
                </template>
              </v-select>
            </v-col>
          </v-row>

          <v-row dense class="mx-4">
            <v-textarea
              outlined
              v-model="modelReparacion.observaciones"
              :dark="dark"
              label="Observaciones"
            ></v-textarea>
          </v-row>
        </v-col>
      </v-row>

      <v-row class="mx-4 mb-2">
        <v-spacer></v-spacer>
        <v-chip
          class="mr-1 px-10"
          label
          :color="colorEBikeAccent1"
          text-color="white"
          link
          @click="_guardarReparacion"
        >
          <h5 v-if="loading" v-bind:style="{ color: 'white' }">Guardando...</h5>
          <h5 v-else v-bind:style="{ color: 'white' }">Guardar</h5>
        </v-chip>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";

export default {
  name: "ReparacionFormulario",
  components: {},
  data: () => ({
    loading: false,
    date1: false,
    date2: false,
  }),

  props: {
    modelReparacion: {
      type: Object,
      required: true,
    },

    accion: {
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapState([
      "drawer",
      "dark",

      "colorEBikeAccent1",

      "colorFondo500",
      "colorFondo400",
      "colorFondo300",
      "colorFondo200",
      "colorFondo100",

      "colorFront500",
      "colorFront400",
      "colorFront300",
      "colorFront200",
      "colorFront100",

      "colorAccent2",
      "colorAccent1",
      "colorBarraFormulario",
    ]),
    ...mapState("auth", [
      "user",
      "date",
      "access_token",
      "error",
      "errorMessage",
    ]),
    ...mapState("bicis", ["bicis"]),
  },

  mounted() {},

  methods: {
    ...mapActions("reparaciones", [
      "getReparaciones",
      "crearReparacion",
      "updateReparacion",
    ]),

    _cerrarVentana() {
      this.$emit("cerrarFormularioReparacion");
    },

    async _guardarReparacion() {
      this.loading = true;
      this.modelReparacion.bici_id = this.modelReparacion.bici.id;
      if (this.accion == "crear") {
        var res = await this.crearReparacion([
          this.access_token,
          this.modelReparacion,
        ]);
        const params = {};
        this._cerrarVentana();
        await this.getReparaciones([this.access_token, params, true]);
      } else if (this.accion == "editar") {
        var res = await this.updateReparacion([
          this.access_token,
          this.modelReparacion,
        ]);
        this._cerrarVentana();
      }
      this.loading = false;
    },
  },
};
</script>
